import { render, staticRenderFns } from "./OA2Providers.vue?vue&type=template&id=33366ba4&scoped=true&"
import script from "./OA2Providers.vue?vue&type=script&lang=js&"
export * from "./OA2Providers.vue?vue&type=script&lang=js&"
import style0 from "./OA2Providers.vue?vue&type=style&index=0&id=33366ba4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33366ba4",
  null
  
)

export default component.exports